import { render, staticRenderFns } from "./AdminPendingInvoicesFilters.vue?vue&type=template&id=1965d674&"
import script from "./AdminPendingInvoicesFilters.vue?vue&type=script&lang=js&"
export * from "./AdminPendingInvoicesFilters.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingInvoicesFilters.vue?vue&type=style&index=0&id=1965d674&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu})
